import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createStaticVNode as _createStaticVNode } from "vue";
const _hoisted_1 = {
  class: "panel astral"
};
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"small-corner-decoration top-left\"></div><div class=\"small-corner-decoration top-right\"></div><div class=\"small-corner-decoration bottom-left\"></div><div class=\"small-corner-decoration bottom-right\"></div><p class=\"title\">ASTRAL</p>", 5);
const _hoisted_7 = {
  key: 0,
  class: "description"
};
const _hoisted_8 = {
  key: 1,
  class: "description"
};
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", {
  class: "icon"
}, null, -1);
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", {
  class: "cost"
}, "FREE", -1);
const _hoisted_11 = {
  class: "buttons-container"
};
const _hoisted_12 = /*#__PURE__*/_createElementVNode("br", null, null, -1);
const _hoisted_13 = {
  key: 0,
  class: "info"
};
const _hoisted_14 = {
  key: 1,
  class: "info"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_input_number = _resolveComponent("el-input-number");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, !_ctx.totalSlots ? (_openBlock(), _createElementBlock("p", _hoisted_7, "no pass owned")) : (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(_ctx.totalSlots - _ctx.maxMint) + " / " + _toDisplayString(_ctx.totalSlots) + " passes used", 1)), _hoisted_9, _hoisted_10, _createElementVNode("div", _hoisted_11, [_createVNode(_component_el_button, {
    text: true,
    onClick: _cache[0] || (_cache[0] = () => {
      this.value > 1 && _ctx.$emit('update:value', this.value - 1);
    }),
    class: "minus-button button"
  }), _createVNode(_component_el_input_number, {
    class: "value",
    "model-value": _ctx.maxMint === 0 ? 0 : _ctx.value,
    min: 1,
    max: _ctx.maxMint === 0 ? 1 : _ctx.maxMint,
    controls: false,
    readonly: true,
    onChange: _cache[1] || (_cache[1] = () => {})
  }, null, 8, ["model-value", "max"]), _createVNode(_component_el_button, {
    text: true,
    onClick: _cache[2] || (_cache[2] = () => {
      this.value < _ctx.maxMint && _ctx.$emit('update:value', this.value + 1);
    }),
    class: "plus-button button"
  })]), _ctx.isCountdownTimerOn ? (_openBlock(), _createBlock(_component_el_button, {
    key: 2,
    text: true,
    onClick: _cache[3] || (_cache[3] = () => {}),
    class: "countdown-button action-button button"
  }, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.countDown.days) + "D:" + _toDisplayString(_ctx.countDown.hours) + "H:" + _toDisplayString(_ctx.countDown.minutes) + "M", 1)]),
    _: 1
  })) : !_ctx.isWalletConnected ? (_openBlock(), _createBlock(_component_el_button, {
    key: 3,
    text: true,
    onClick: _ctx.connectWallet,
    class: "connect-button action-button button"
  }, {
    default: _withCtx(() => [_createTextVNode("CONNECT")]),
    _: 1
  }, 8, ["onClick"])) : _ctx.maxMint > 0 && !_ctx.isPhasePaused ? (_openBlock(), _createBlock(_component_el_button, {
    key: 4,
    text: true,
    onClick: _ctx.mint,
    class: "mint-button action-button button"
  }, {
    default: _withCtx(() => [_createTextVNode("MINT")]),
    _: 1
  }, 8, ["onClick"])) : (_openBlock(), _createBlock(_component_el_button, {
    key: 5,
    text: true,
    onClick: _cache[4] || (_cache[4] = () => {}),
    class: "ineligible-button action-button button"
  }, {
    default: _withCtx(() => [_createTextVNode(" INELIGIBLE"), _hoisted_12, _ctx.isPhasePaused ? (_openBlock(), _createElementBlock("span", _hoisted_13, "phase not active")) : _ctx.maxMint <= 0 ? (_openBlock(), _createElementBlock("span", _hoisted_14, "no pass owned")) : _createCommentVNode("", true)]),
    _: 1
  }))]);
}